import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = {
  id: "modal-container-element",
  class: "filter-block"
}
const _hoisted_3 = ["placeholder"]
const _hoisted_4 = { class: "cards-container" }
const _hoisted_5 = ["card-title", "description", "icon-src", "icon-name", "onClick"]

import { useStore } from 'vuex'
import { ref, computed, onMounted, onUnmounted } from 'vue'

import { EPINIO_TYPES } from '../types'

import Loading from '@shell/components/Loading.vue'
import { startPolling, stopPolling } from '../utils/polling';


export default /*@__PURE__*/_defineComponent({
  __name: 'catalogservices',
  props: {
    schema: {}
  },
  setup(__props: any) {

const store = useStore()
const props = __props; // eslint-disable-line @typescript-eslint/no-unused-vars

const pending = ref(true);
const searchQuery = ref(null);

onMounted(async () => {
  await store.dispatch(`epinio/findAll`, { type: EPINIO_TYPES.CATALOG_SERVICE });
  pending.value = false;

  startPolling(["namespaces", "applications", "catalogservices", "services"], store);
});

onUnmounted(() => {
  stopPolling(["namespaces", "applications", "catalogservices", "services"]);
});

const list = computed(() => {
  const catalogList = store.getters['epinio/all'](EPINIO_TYPES.CATALOG_SERVICE)

  if (!searchQuery.value) {
    return catalogList;
  } else {
    const query = searchQuery.value.toLowerCase();

    return catalogList.filter((e) => e?.chart.toLowerCase().includes(query) ||
      e?.description.toLowerCase().includes(query) ||
      e?.short_description.toLowerCase().includes(query));
  }
})

const showDetails = (chart: any) => {
  store.$router.push(chart.detailLocation)
}


return (_ctx: any,_cache: any) => {
  return (pending.value)
    ? (_openBlock(), _createBlock(Loading, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives(_createElementVNode("trailhand-text-input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
            type: "search",
            class: "input-sm",
            placeholder: _ctx.t('catalog.charts.search')
          }, null, 8, _hoisted_3), [
            [_vModelText, searchQuery.value]
          ])
        ]),
        _cache[1] || (_cache[1] = _createTextVNode()),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (service) => {
            return (_openBlock(), _createElementBlock("trailhand-card", {
              key: service.id,
              "card-title": service.meta.name,
              description: service.short_description,
              "icon-src": service.serviceIcon ? service.serviceIcon : null,
              "icon-name": service.serviceIcon ? null : 'database',
              clickable: "",
              onClick: ($event: any) => (showDetails(service))
            }, null, 8, _hoisted_5))
          }), 128))
        ])
      ]))
}
}

})